<template>
  <div class="card">
    <div class="card-header border-0">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="mb-0">Productos</h3>
        </div>
        <div class="col text-right">
          <a href="#/Products" class="btn btn-sm btn-primary btn_info_list">Ver todos</a>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table thead-classes="thead-light"
                  :data="tableData">
        <template slot="columns">
          <th>Producto</th>
          <th>Categoria</th>
          <th>Unidad de medida</th>
          <!--        <th>Bounce rate</th>-->
        </template>

        <template slot-scope="{row}">
          <th scope="row">
            {{ row.name }}
          </th>
          <td>
            {{ row.Category.category }}
          </td>
          <td>
           <div v-for="(item,index) in jsonparse(row.unit)" :key="index">
             <span>{{item.unit_name}}</span>
           </div>
          </td>
          <!--          <td>
                      <i class="fas fa-arrow-up text-success mr-3"
                         :class="row.bounceRateDirection === 'up' ? 'text-success': 'text-danger'">
                      </i>
                      {{row.bounceRate}}
                    </td>-->
        </template>

      </base-table>
    </div>

  </div>
</template>
<script>
import {product_service} from "@/services/product/ProductService";
import {bus} from "@/components/Product/bus-product";

export default {
  name: 'page-visits-table',
  data() {
    return {
      page_count: 0,
      tableData: []
    }
  },
  methods:{
    jsonparse(arr){
      return JSON.parse(arr)
    }
  },
  created() {
    product_service.GetAllProduct()
    bus.$on('GetAllProduct', (response, value) => {
      this.tableData = response
      this.page_count = Math.ceil(value / 10)
    })
  }
}
</script>
<style>
</style>
